<div class="flex h-[50rem] w-[min(65rem,90vw)] flex-col gap-2" *transloco="let t">
  <keyword-list-manager
    class="min-h-0 flex-1"
    [addInputPlaceholder]="t('brand-alias-modal.enter_list_name_brand_placeholder')"
    [maxWordPerKeyword]="4"
    [targetingMode]="false"
    [initTargetings]="toTargetings()"
    (targetingsChanged)="onKeywordsChanged($event)"
  />
  <div class="flex justify-end gap-2" *transloco="let t">
    <IButton label="{{ t('common.close') }}" color="white" (onClick)="close()" />
  </div>
</div>
